import slugify from "slugify"

export const getProductionSlug = (title: string) => slugify(`prod-${title}`)
export const getTagSlug = (name: string) => slugify(name)
export const getCreationSlug = (title: string) => slugify(`creation-${title}`)
export const getAuthorSlug = (name: string) => slugify(name)
